import { render, staticRenderFns } from "./CategoryOrPm.vue?vue&type=template&id=5c6c7413&scoped=true&"
import script from "./CategoryOrPm.vue?vue&type=script&lang=js&"
export * from "./CategoryOrPm.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOrPm.vue?vue&type=style&index=0&id=5c6c7413&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c7413",
  null
  
)

export default component.exports